var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.54 8.54a.65.65 0 0 1 .92 0l6 6a.65.65 0 1 1-.92.92L12 9.92l-5.54 5.54a.65.65 0 1 1-.92-.92l6-6Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41NDA0IDguNTQwMzhDMTEuNzk0MiA4LjI4NjU0IDEyLjIwNTggOC4yODY1NCAxMi40NTk2IDguNTQwMzhMMTguNDU5NiAxNC41NDA0QzE4LjcxMzUgMTQuNzk0MiAxOC43MTM1IDE1LjIwNTggMTguNDU5NiAxNS40NTk2QzE4LjIwNTggMTUuNzEzNSAxNy43OTQyIDE1LjcxMzUgMTcuNTQwNCAxNS40NTk2TDEyIDkuOTE5MjRMNi40NTk2MyAxNS40NTk2QzYuMjA1NzggMTUuNzEzNSA1Ljc5NDIzIDE1LjcxMzUgNS41NDAzOSAxNS40NTk2QzUuMjg2NTUgMTUuMjA1OCA1LjI4NjU1IDE0Ljc5NDIgNS41NDAzOSAxNC41NDA0TDExLjU0MDQgOC41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";